/**
 * Design tokeny kitu — NAMERENE hodnoty (pixel histogram z referenci,
 * kokpit-design-reference.png + REOS podklad), viz zadani KIT v0 §3.
 * Neodhadovat, nemenit bez noveho mereni.
 */
export const tokens = {
    color: {
        /** Platno aplikace per produkt. */
        canvas: {
            kokpit: '#f2f3f6',
            reos: '#f4f6f8',
            fakturace: '#f3f4f6',
        },
        /** Karta (povrch) — spolecna. */
        card: '#fefefe',
        /** Border rodina #eeeeee. */
        border: '#eeeeee',
        borderStrong: '#e2e4e8',
        /** Akcent per produkt; fakturace = 2 kandidati (A default), vybere R.B. v galerii. */
        accent: {
            kokpit: '#4041e8',
            reos: '#2963cb',
            fakturaceA: '#047857',
            fakturaceB: '#0f766e',
            /**
             * REDREAL zlata (rozhodl R.B., blok 1). Jen dekorativni akcent:
             * na bile karte ma 2,7:1, takze NESMI byt theme `accent`
             * (compileTheme fail-fast vyzaduje 4,5:1 pro odkazy).
             */
            redreal: '#C99441',
        },
        /** Textove barvy dovzorkovane z nadpisu referenci. */
        text: '#16181d',
        textMuted: '#5f6570',
        /** Stavove rodiny (success pozadi #d7f0e7 dle zadani). */
        success: '#116149',
        successBg: '#d7f0e7',
        warning: '#7a4d0b',
        warningBg: '#f6ecd4',
        danger: '#b3261e',
        dangerBg: '#fbe4e1',
    },
    /** Radius zmereny z reference: karty 16, ovladaci prvky 10, vnejsi ram 24. */
    radius: {
        control: '10px',
        card: '16px',
        shell: '24px',
        pill: '999px',
    },
    spacing: {
        xs: '4px',
        sm: '8px',
        md: '16px',
        lg: '24px',
        xl: '32px',
    },
    typography: {
        /** Inter variable, self-host subset cs (fonts/inter-cs.woff2), metric-adjusted fallback. */
        fontSans: "'InterVar', 'Inter Fallback', system-ui, -apple-system, 'Segoe UI', sans-serif",
        fontSize: {
            xs: '12px',
            sm: '13px',
            base: '14px',
            md: '16px',
            lg: '20px',
            xl: '28px',
        },
    },
};
//# sourceMappingURL=tokens.js.map